import { DRNUtil } from '@traveloka/district-util';
export default class SmartKeyBinder {
    constructor(props, smartKeyName) {
        this.ensureValue = (...values) => {
            return values.find(value => value !== null && value !== undefined);
        };
        this.getBindablePropsIfSingleSmartKeyDelegate = (bindableProps, smartKeyName, smartKey, smartKeyParams) => {
            if (smartKeyName != null) {
                this.bindProp(bindableProps, smartKeyName, this.ensureValue(this.props[smartKeyName], this.i18n.t(smartKey, smartKeyParams), smartKey));
            }
            this.bindAccessibility(bindableProps, smartKey, smartKeyParams);
        };
        this.getBindablePropsIfMultipleSmartKeysDelegate = (bindableProps, smartKeyNames, smartKey, smartKeyParams) => {
            if (smartKeyNames != null) {
                smartKeyNames.forEach(smartKeyName => {
                    this.bindProp(bindableProps, smartKeyName, this.ensureValue(this.props[smartKeyName], this.i18n.t(smartKey[smartKeyName], smartKeyParams != null ? smartKeyParams[smartKeyName] : {}), smartKey[smartKeyName]));
                });
            }
            this.bindAccessibility(bindableProps, smartKey ? smartKey.accessibilityLabel : null, smartKeyParams ? smartKeyParams.accessibilityLabel : null);
        };
        this.bindAccessibility = (bindableProps, accessibilityLabel, accessibilityLabelParams) => {
            if (accessibilityLabel != null) {
                const isIOSDev = DRNUtil.isiOS() && this.isDev;
                const accessibilityLabelName = isIOSDev ? 'testID' : 'accessibilityLabel';
                if (isIOSDev) {
                    bindableProps.accessible = true;
                }
                this.bindProp(bindableProps, accessibilityLabelName, this.ensureValue(this.props[accessibilityLabelName], this.isDev ? accessibilityLabel : null, this.a11y.t(accessibilityLabel, accessibilityLabelParams || {}), accessibilityLabel));
            }
        };
        this.bindProp = (bindableProps, propName, value) => {
            if (value != null) {
                bindableProps[propName] = value;
            }
        };
        this.getBindableProps = (i18n, a11y, props, isDev, withSmartKeyProps) => {
            const { smartKey } = withSmartKeyProps;
            this.props = props;
            this.i18n = i18n;
            this.a11y = a11y;
            this.isDev = isDev;
            if (smartKey != null) {
                return this.bindSmartKey(withSmartKeyProps, this.getBindablePropsIfSingleSmartKeyDelegate, this.getBindablePropsIfMultipleSmartKeysDelegate);
            }
            return {};
        };
        this.bindSmartKey = (withSmartKeyProps, ifSingleSmartKeyDelegate, ifMultipleSmartKeysDelegate) => {
            const bindableProps = {};
            const { smartKey, smartKeyParams } = withSmartKeyProps;
            if (Array.isArray(this.smartKeyName) || typeof smartKey === 'object') {
                ifMultipleSmartKeysDelegate(bindableProps, Array.isArray(this.smartKeyName) ? this.smartKeyName : [this.smartKeyName], smartKey, smartKeyParams);
            }
            else {
                ifSingleSmartKeyDelegate(bindableProps, this.smartKeyName, smartKey, smartKeyParams);
            }
            return bindableProps;
        };
        this.props = props;
        this.smartKeyName = smartKeyName;
    }
}
